module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0098.jpg?v=b173089a";